/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SiteOperationsMapZoneResponseDto } from './SiteOperationsMapZoneResponseDto';
import {
    SiteOperationsMapZoneResponseDtoFromJSON,
    SiteOperationsMapZoneResponseDtoFromJSONTyped,
    SiteOperationsMapZoneResponseDtoToJSON,
    SiteOperationsMapZoneResponseDtoToJSONTyped,
} from './SiteOperationsMapZoneResponseDto';
import type { SiteOperationsMapSummaryResponseDto } from './SiteOperationsMapSummaryResponseDto';
import {
    SiteOperationsMapSummaryResponseDtoFromJSON,
    SiteOperationsMapSummaryResponseDtoFromJSONTyped,
    SiteOperationsMapSummaryResponseDtoToJSON,
    SiteOperationsMapSummaryResponseDtoToJSONTyped,
} from './SiteOperationsMapSummaryResponseDto';
import type { SiteOperationsMapSiteResponseDto } from './SiteOperationsMapSiteResponseDto';
import {
    SiteOperationsMapSiteResponseDtoFromJSON,
    SiteOperationsMapSiteResponseDtoFromJSONTyped,
    SiteOperationsMapSiteResponseDtoToJSON,
    SiteOperationsMapSiteResponseDtoToJSONTyped,
} from './SiteOperationsMapSiteResponseDto';

/**
 * 
 * @export
 * @interface GetSiteOperationsMapResponseDto
 */
export interface GetSiteOperationsMapResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetSiteOperationsMapResponseDto
     */
    organizationId: string;
    /**
     * 
     * @type {SiteOperationsMapSummaryResponseDto}
     * @memberof GetSiteOperationsMapResponseDto
     */
    summary: SiteOperationsMapSummaryResponseDto;
    /**
     * 
     * @type {Array<SiteOperationsMapSiteResponseDto>}
     * @memberof GetSiteOperationsMapResponseDto
     */
    sites: Array<SiteOperationsMapSiteResponseDto>;
    /**
     * 
     * @type {Array<SiteOperationsMapZoneResponseDto>}
     * @memberof GetSiteOperationsMapResponseDto
     */
    zones: Array<SiteOperationsMapZoneResponseDto>;
}

/**
 * Check if a given object implements the GetSiteOperationsMapResponseDto interface.
 */
export function instanceOfGetSiteOperationsMapResponseDto(value: object): value is GetSiteOperationsMapResponseDto {
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    if (!('sites' in value) || value['sites'] === undefined) return false;
    if (!('zones' in value) || value['zones'] === undefined) return false;
    return true;
}

export function GetSiteOperationsMapResponseDtoFromJSON(json: any): GetSiteOperationsMapResponseDto {
    return GetSiteOperationsMapResponseDtoFromJSONTyped(json, false);
}

export function GetSiteOperationsMapResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSiteOperationsMapResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationId': json['organizationId'],
        'summary': SiteOperationsMapSummaryResponseDtoFromJSON(json['summary']),
        'sites': ((json['sites'] as Array<any>).map(SiteOperationsMapSiteResponseDtoFromJSON)),
        'zones': ((json['zones'] as Array<any>).map(SiteOperationsMapZoneResponseDtoFromJSON)),
    };
}

export function GetSiteOperationsMapResponseDtoToJSON(json: any): GetSiteOperationsMapResponseDto {
    return GetSiteOperationsMapResponseDtoToJSONTyped(json, false);
}

export function GetSiteOperationsMapResponseDtoToJSONTyped(value?: GetSiteOperationsMapResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organizationId': value['organizationId'],
        'summary': SiteOperationsMapSummaryResponseDtoToJSON(value['summary']),
        'sites': ((value['sites'] as Array<any>).map(SiteOperationsMapSiteResponseDtoToJSON)),
        'zones': ((value['zones'] as Array<any>).map(SiteOperationsMapZoneResponseDtoToJSON)),
    };
}

